import React, {
  ButtonHTMLAttributes,
  ForwardedRef,
  forwardRef,
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from 'react'
import './BpButton.css'
import { IIconProps } from '../../../types/IconProps.interface'
import { Preloader } from '../../cards/preloader/Preloader'

export interface IBpButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg'
  theme?: 'default' | 'danger' | 'outline' | 'light' | 'transparent'
  children?: ReactNode
  active?: boolean
  loading?: boolean
  contentClassName?: string
  iconLeft?: ReactElement<PropsWithChildren<IIconProps>>
  iconRight?: false | ReactElement<PropsWithChildren<IIconProps>>
}

interface IBpIconProps extends React.HTMLAttributes<HTMLElement> {
  iconPosition?: 'left' | 'right'
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export const BpButton = forwardRef(
  (props: IBpButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
    const {
      children,
      size = 'md',
      disabled = false,
      iconLeft,
      iconRight,
      theme = 'default',
      active = false,
      loading = false,
      className,
      contentClassName,
      ...btnProps
    } = props
    return (
      <button
        ref={ref}
        className={`bp-btn group relative ${size} ${theme} ${active && 'active'} ${loading && 'pointer-events-none !bg-[#E8EDF2]'} ${className} `}
        disabled={disabled}
        {...btnProps}
      >
        <div className={`flex justify-center gap-[8px] align-middle ${loading && 'invisible'}`}>
          {iconLeft && (
            <IconElem iconPosition='left' size={size}>
              {iconLeft}
            </IconElem>
          )}
          {children && (
            <span
              className={`whitespace-nowrap font-medium ${
                {
                  default: 'text-white',
                  danger: 'text-white',
                  outline: 'text-focus-500 group-hover:text-default group-disabled:text-aqua-300',
                  light: 'text-default',
                  transparent:
                    'font-normal text-focus-500 group-hover:text-default group-disabled:text-aqua-300',
                }[theme]
              } ${contentClassName}`}
            >
              {children}
            </span>
          )}
          {iconRight && (
            <IconElem iconPosition='right' size={size}>
              {iconRight}
            </IconElem>
          )}
        </div>
        {loading && (
          <div className={'absolute inset-0 m-auto h-[20px] w-[20px] overflow-hidden'}>
            <Preloader />
          </div>
        )}
      </button>
    )
  },
)
const IconElem = ({ children, size }: IBpIconProps) => (
  <span
    className={`flex content-center items-center ${{ xs: 'w-[12px]', sm: 'w-[15px]', md: 'w-[15px]', lg: 'w-[15px]', xl: 'w-[15px]' }[size ?? 'md']}`}
  >
    {children}
  </span>
)
